import request from '@/utils/httpRequest'

export default class FlowSettingService {
    queryTreeData() {
        return request({
            url: '/v3/api/app/flow/treeData',
            method: 'get'
        })
    }

    queryRightData(params) {
        return request({
            url: '/v3/api/app/flow/todoNumber',
            method: 'get',
            params
        })
    }

    queryToDoList(params) {
        return request({
            url: '/v3/api/app/flow/todo',
            method: 'get',
            params
        })
    }

    queryHistoricList(params) {
        return request({
            url: '/v3/api/app/flow/historic',
            method: 'get',
            params
        })
    }

    queryMyApplyedList(params) {
        return request({
            url: '/v3/api/app/flow/myApplyed',
            method: 'get',
            params
        })
    }

    viewFlowRecord(id) {
        return request({
            url: '/v3/api/app/flow/historicTaskList',
            method: 'get',
            params: {
                procInsId: id
            }
        })
    }

    queryUser(id){
        return request({
            url: `/sys/user/queryById`,
            method: 'get',
            params: {id: id}
        })
    }

    queryCreateUserByUserId(id) {
        return request({
            url: `/flowable/flowTaskInfo/queryCreateUserByUserId`,
            method: 'get',
            params: {userId: id}
        })
    }
}